import type { AppErrorCode } from "../errors/types";

type Props = {
  code: AppErrorCode | null;
  message: string;
  onDismiss: () => void;
};

const TONE: Record<AppErrorCode, "warn" | "info"> = {
  "mic-not-supported": "info",
  "mic-permission-denied": "warn",
  "mic-no-audio": "warn",
  "stt-failed": "warn",
  "stt-empty": "warn",
  "structure-failed": "warn",
  "tts-failed": "warn",
  offline: "info",
  "submit-failed": "warn",
};

export function ErrorBanner({ code, message, onDismiss }: Props) {
  if (!code) return null;
  const tone = TONE[code];
  const bg =
    tone === "warn"
      ? "bg-amber-50 border-amber-300 text-amber-800"
      : "bg-blue-50 border-blue-300 text-blue-800";
  return (
    <div role="alert" className={`border rounded p-3 my-3 flex items-start gap-3 ${bg}`}>
      <div className="flex-1 text-sm">{message}</div>
      {/* min-h-[44px] + px-3 は Apple HIG のタップ領域 (元は padding ゼロで約 36x16)。
          shrink-0 は長い message で押せる幅が 44px を割らないため。 */}
      <button
        type="button"
        onClick={onDismiss}
        className="shrink-0 inline-flex items-center min-h-[44px] px-3 text-xs underline"
      >
        閉じる
      </button>
    </div>
  );
}
